import React from 'react';
import styled from 'styled-components';
import StoreFilter from './component/StoreFilter';
import StoreTable from './component/StoreTable';

const StoreManagementPage = () => {
  return (
    <Container>
      <StoreFilter />
      <StoreTable />
    </Container>
  );
};

export default StoreManagementPage;

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
